import { pageMap, regionMap } from '@/constants/tea';
const channelMap = {
  id: 'sg',
  en: 'va',
  zh: 'sg',
  th: 'sg',
  ph: 'sg',
  vn: 'sg',
  my: 'sg',
  sg: 'sg'
};
export class TeaLogger {
  constructor({
    region,
    page_name
  }) {
    const Tea = require('@dp/byted-tea-sdk-oversea').default;

    Tea.init({
      app_id: APP_ID,
      channel: IS_TTP ? 'ttp' : channelMap[region] || 'sg',
      channel_type: IS_TTP ? 'ttp' : 'tcpy'
    });
    Tea.config({});
    Tea.start();
    this.tea = Tea;
    this.commonParams = {
      EVENT_ORIGIN_FEATURE: 'TEMAI',
      region: regionMap[region],
      page_name: pageMap[page_name]
    };
  }

  send(eventName, params) {
    this.tea.event(eventName, Object.assign(Object.assign({}, this.commonParams), params));
  }

}